import React, {Component} from "react";
import Auxiliary from '../../../hoc/Auxiliary/Auxiliary'
import queryString from "query-string";
import instance from "../../../axios-spc";
import classes from "../../TakePhoto/TakePhoto.css";
import IMAGES from "../../../store/images";

class Ddt extends Component {

    state = {
        spedizione: null
    };

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);
        let idSpedizione = params.id;
        var postData = {
            id_spedizione: idSpedizione

        };
        instance.post('/getDdt', postData)
        // axios.post('http://localhost:8989/api/getDdt', postData, axiosConfig)
            .then(response => {
                this.setState({spedizione: response.data[0]});
            })
            .catch(error => {
                console.log(error);
                this.setState({loading: false});
            });
    }

    formatDate(value) {
        let date = new Date(value);
        const day = date.toLocaleString('default', { day: '2-digit' });
        const month = date.toLocaleString('default', { month: '2-digit' });
        const year = date.toLocaleString('default', { year: 'numeric' });
        return day + '-' + month + '-' + year;
    }

    inserisciDatiDdt = () => {
        let doc = document.getElementById("ddt_interno");
        let svgDoc = doc.contentDocument;
        let svgElement = svgDoc.getElementById("Livello_1");
        const indirizzo = svgElement.getElementById("indirizzo");
        const id_sped = svgElement.getElementById("id_sped");
        const data_sped = svgElement.getElementById("data_sped");
        const note = svgElement.getElementById("note");

        indirizzo.innerHTML = this.state.spedizione.mittente_indirizzo + " " + this.state.spedizione.mittente_citta + " " + this.state.spedizione.mittente_cap + " " + "(" + this.state.spedizione.mittente_provincia + ")";
        id_sped.innerHTML = this.state.spedizione.numero_ddt;
        note.innerHTML = this.state.spedizione.numero_colli + " pz. - Consegna presso Sede Eco Store";
        data_sped.innerHTML = this.formatDate(this.state.spedizione.data);
        indirizzo.style.fontSize = "35px";
        note.style.fontSize = "30px";
    };

    render() {

        let ddt = null;
        if (this.state.spedizione) {
            ddt = (
                <div className={classes.Print}>
                    <object data={IMAGES.ddtInterno} id="ddt_interno" type="image/svg+xml"
                            onLoad={() => this.inserisciDatiDdt()}/>
                </div>
            );
        }

        return (
            <Auxiliary>
                {ddt}
            </Auxiliary>
        )
    }
}

export default Ddt;
